import { render, staticRenderFns } from "./branch-list.vue?vue&type=template&id=0bf67e4c&scoped=true"
import script from "./branch-list.vue?vue&type=script&lang=js"
export * from "./branch-list.vue?vue&type=script&lang=js"
import style0 from "./branch-list.vue?vue&type=style&index=0&id=0bf67e4c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf67e4c",
  null
  
)

export default component.exports